import React from "react";
import { refreshToken } from "services/http/auth";
import * as storage from "services/utility/storage"; 
import { connect } from 'react-redux';
import { logoutAuth, companyChange } from "services/http/auth";

import {
    Row,
    Modal,
    Col,
    Button
} from "reactstrap";


class InfoRefreshTokenPopup extends React.Component {
    handleClose = () => {
        this.props.closePopUp()
    }

    refreshTimer = null;

    ok = () => {
        refreshToken();
        clearInterval(this.refreshTimer);
        this.props.closePopUp();
    }

    closeInfoPopUp = () => { 
        if (this.props.showPopUp){
            this.refreshTimer = setInterval(() =>
            this.isTokenExpiredClosePopup(), 500);
        } 
    }

    closeModal = () => {
        clearInterval(this.refreshTimer);
        this.props.closePopUp();
    };

    isTokenExpiredClosePopup = () => { 
        if (!storage.refreshTokenWithInterval()) {
            this.closeModal();
        }
        let token = storage.getCurrentToken(); 
        if (token == null || !storage.getTokenExpirationDate() || storage.getTokenExpirationDate().valueOf() < new Date().valueOf()) {
            this.closeModal();
            this.props.logoutAuth();
        }
    }

    render() {
        if(this.props.showPopUp){
            this.closeInfoPopUp();
        }

        return (
            <>
                <Modal
                    isOpen={this.props.showPopUp}
                    toggle={() => this.handleClose()} size="md" backdrop="static" >

                    <div className="modal-header">
                        <h6 className="modal-title" id="modal-title-danger">
                            Session Timeout
                        </h6>
                        <button
                            aria-label="Close"
                            className="close"
                            data-dismiss="modal"
                            type="button"
                            onClick={() => this.handleClose()}
                        >
                            <span aria-hidden={true}>×</span>
                        </button>
                    </div>

                    <div className="modal-body modal-body pb-0 pt-0">
                        <Row>
                            <Col className="mb-3" md="12">
                                Your session is about to Expire !. Click ok to Continue. "
                            </Col>
                        </Row>
                    </div>
                    <div className="modal-footer p-2">
                        <Button
                            className="btn-md"
                            color="primary"
                            data-dismiss="modal"
                            type="button"
                            onClick={() => this.ok()}>
                            OK</Button>

                    </div>
                </Modal>
            </>

        );
    }
}

const mapStateToProps = (state) => {
    return {
      auth: state.auth 
    }
  }

const mapDispatchToProps = dispatch => {
    return {
      logoutAuth: () => dispatch(logoutAuth()),
      companyChange: (code) => dispatch(companyChange(code))
    }
  }

export default connect(mapStateToProps, mapDispatchToProps)(InfoRefreshTokenPopup) 